var map = {
	"./rectangle-1.svg": 1211,
	"./rectangle-10.svg": 1212,
	"./rectangle-11.svg": 1213,
	"./rectangle-12.svg": 1214,
	"./rectangle-13.svg": 1215,
	"./rectangle-14.svg": 1216,
	"./rectangle-15.svg": 1217,
	"./rectangle-16.svg": 1218,
	"./rectangle-17.svg": 1219,
	"./rectangle-18.svg": 1220,
	"./rectangle-19.svg": 1221,
	"./rectangle-2.svg": 1222,
	"./rectangle-20.svg": 1223,
	"./rectangle-21.svg": 1224,
	"./rectangle-22.svg": 1225,
	"./rectangle-23.svg": 1226,
	"./rectangle-24.svg": 1227,
	"./rectangle-3.svg": 1228,
	"./rectangle-4.svg": 1229,
	"./rectangle-5.svg": 1230,
	"./rectangle-6.svg": 1231,
	"./rectangle-7.svg": 1232,
	"./rectangle-8.svg": 1233,
	"./rectangle-9.svg": 1234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1210;